class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.config = JSON.parse(this.querySelector('.config').textContent);
        
        console.log(this.config);
    }
    connectedCallback() {
        this.slider = new Swiper(this, this.config);
    }
}

if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', SwiperSlider)
}
